// import React, { useState, useEffect } from "react";
// import "./ApplyForLeave.css";
// import Navbar from "./common/Navbar";
// import Footer from "./common/Footer";
// import Sidebar from "./common/Sidebar";
// import { Grid, Card, CardContent, Typography, Box, Avatar } from "@mui/material";
// import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
// const BASE_URL = process.env.REACT_APP_BASE_URL;

// const LeaveRequestForm = () => {
//   const [leaveType, setLeaveType] = useState("");
//   const [startDate, setStartDate] = useState("");
//   const [endDate, setEndDate] = useState("");
//   const [reason, setReason] = useState("");
//   const [message, setMessage] = useState("");
//   const [error, setError] = useState("");
//   const [remainingLeaves, setRemainingLeaves] = useState(null);

//   useEffect(() => {
//     const fetchRemainingLeaves = async () => {
//       try {
//         const token = sessionStorage.getItem("token");
//         if (!token) {
//           setError("No token found. Please log in.");
//           return;
//         }

//         const response = await fetch(
//           `/api/employees/leaves/remainingleaves`,
//           {
//             method: "GET",
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Content-Type": "application/json",
//             },
//           }
//         );

//         if (!response.ok) {
//           throw new Error("Error fetching remaining leaves");
//         }

//         const data = await response.json();
//         setRemainingLeaves(data.remainingLeave);
//         setError("");
//       } catch (err) {
//         console.error("Error:", err);
//         setError("Error fetching remaining leaves");
//       }
//     };

//     fetchRemainingLeaves();
//   }, []);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const token = sessionStorage.getItem("token");
//       if (!token) {
//         setError("No token found. Please log in.");
//         return;
//       }

//       const decodedToken = JSON.parse(atob(token.split(".")[1]));
//       const employeeId = decodedToken.employee.id;

//       const requestBody = {
//         employeeId,
//         leaveType,
//         startDate,
//         endDate,
//         reason,
//       };

//       const response = await fetch(`/api/leave/requests`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(requestBody),
//       });

//       const data = await response.json();

//       if (!response.ok) {
//         throw new Error(data.msg || "Error submitting leave request");
//       }

//       setMessage(data.msg);
//       setError("");
//       setLeaveType("");
//       setStartDate("");
//       setEndDate("");
//       setReason("");

//       window.location.reload();
//     } catch (err) {
//       console.error("Error:", err);
//       setError(err.message || "Error submitting leave request");
//       setMessage("");
//     }
//   };

//   const handleStartDateChange = (e) => {
//     const selectedStartDate = e.target.value;
//     setStartDate(selectedStartDate);
//     if (endDate < selectedStartDate) {
//       setEndDate(selectedStartDate);
//     }
//   };

//   return (
//     <div className="leave-application-container">
//       <Navbar />
//       <Sidebar />

//       <div className="leave-application-content">
//         <div className="leave-application-header">
//           <h2 className="leave-application-title">Leave Application</h2>
//           <p className="leave-application-subtitle">
//             Submit your leave request for approval
//           </p>
//         </div>

//         <div className="leave-application-grid">
//           {/* Leave Balance Card */}
//           <div className="leave-balance-card">
//             <h3 className="leave-balance-title">Your Leave Balance</h3>
//             {remainingLeaves ? (
//               <div className="leave-balance-items">
//                 <div className="leave-balance-item">
//                   <span className="leave-type">Annual Leave</span>
//                   <span className="leave-count">
//                     {remainingLeaves.annualLeave}
//                   </span>
//                 </div>
//                 <div className="leave-balance-item">
//                   <span className="leave-type">Sick Leave</span>
//                   <span className="leave-count">
//                     {remainingLeaves.sickLeave}
//                   </span>
//                 </div>
//                 <div className="leave-balance-item">
//                   <span className="leave-type">Casual Leave</span>
//                   <span className="leave-count">
//                     {remainingLeaves.casualleave}
//                   </span>
//                 </div>
//                 <div className="leave-balance-item">
//                   <span className="leave-type">Other Leave</span>
//                   <span className="leave-count">{remainingLeaves.Other}</span>
//                 </div>
//               </div>
//             ) : (
//               <div className="leave-balance-loading">
//                 Loading leave balances...
//               </div>
//             )}
//           </div>

//           {/* Leave Request Form */}
//           <div className="leave-request-card">
//             <h3 className="leave-request-title">Request New Leave</h3>
//             <form onSubmit={handleSubmit} className="leave-request-form">
//               <div className="form-group">
//                 <label htmlFor="leaveType" className="form-label">
//                   Leave Type
//                 </label>
//                 <select
//                   id="leaveType"
//                   value={leaveType}
//                   onChange={(e) => setLeaveType(e.target.value)}
//                   className="form-select"
//                   required
//                 >
//                   <option value="">Select Leave Type</option>
//                   <option value="earned">Annual/Earned Leave</option>
//                   <option value="sick">Sick Leave</option>
//                   <option value="casual">Casual Leave</option>
//                   <option value="other">Other</option>
//                 </select>
//               </div>

//               <div className="form-row">
//                 <div className="form-group">
//                   <label htmlFor="startDate" className="form-label">
//                     Start Date
//                   </label>
//                   <input
//                     type="date"
//                     id="startDate"
//                     value={startDate}
//                     onChange={handleStartDateChange}
//                     className="form-input"
//                     required
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label htmlFor="endDate" className="form-label">
//                     End Date
//                   </label>
//                   <input
//                     type="date"
//                     id="endDate"
//                     value={endDate}
//                     onChange={(e) => setEndDate(e.target.value)}
//                     className="form-input"
//                     required
//                     min={startDate}
//                   />
//                 </div>
//               </div>

//               <div className="form-group">
//                 <label htmlFor="reason" className="form-label">
//                   Reason for Leave
//                 </label>
//                 <textarea
//                   id="reason"
//                   value={reason}
//                   onChange={(e) => setReason(e.target.value)}
//                   className="form-textarea"
//                   rows="4"
//                 />
//               </div>

//               <button type="submit" className="submit-button">
//                 Submit Leave Request
//               </button>

//               {message && (
//                 <div className="alert-message success">{message}</div>
//               )}
//               {error && <div className="alert-message error">{error}</div>}
//             </form>
//           </div>
//         </div>
//       </div>

//       <Footer />
//     </div>
//   );
// };

// export default LeaveRequestForm;




/////////////////////Rishabh version start hear

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Grid,
  Typography,
  Box,
  TextField,
  MenuItem,
  Button,
  Alert,
  Snackbar,
  CircularProgress,
  FormControlLabel,
  Switch,
  RadioGroup,
  Radio,
  Chip,
  Skeleton,
  Stack,
} from "@mui/material";
import BeachAccessOutlinedIcon from "@mui/icons-material/BeachAccessOutlined";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import EventAvailableOutlinedIcon from "@mui/icons-material/EventAvailableOutlined";
import { PageHeader, SectionCard } from "../ui";
import { sortByLabel } from "../../utils/sortOptions";
import { endpoints } from "../../api/endpoints";
import LeaveBalanceCards from "./LeaveBalanceCards";
import { LeaveApplyAllocationPreview } from "./leaveAllocationUi";

const COMP_OFF_LEAVE_VALUE = "compOff";
const LOP_LEAVE_VALUE = "lop";

const COMP_OFF_OPTION = { value: COMP_OFF_LEAVE_VALUE, label: "Compensatory Off", compOffOnly: true };
const LOP_OPTION = {
  value: LOP_LEAVE_VALUE,
  label: "Loss of Pay (LOP)",
  lopOnly: true,
  description: "Unpaid leave — no paid balance required",
};

const LeaveRequestForm = () => {
  const nav = useNavigate();
  const [leaveType, setLeaveType] = useState("");
  const [leaveTypeOptions, setLeaveTypeOptions] = useState([COMP_OFF_OPTION]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [reason, setReason] = useState("");
  const [halfDay, setHalfDay] = useState(false);
  const [halfDaySlot, setHalfDaySlot] = useState("first");
  const [error, setError] = useState("");
  const [remainingLeaves, setRemainingLeaves] = useState(null);
  const [compOffAvailable, setCompOffAvailable] = useState(0);
  const [lopDaysTaken, setLopDaysTaken] = useState(0);
  const [insufficientBalanceHint, setInsufficientBalanceHint] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [successBanner, setSuccessBanner] = useState({ open: false, message: "" });
  const [errorBanner, setErrorBanner] = useState({ open: false, message: "" });
  const [dayPreview, setDayPreview] = useState(null);
  const [allocationPreview, setAllocationPreview] = useState(null);
  const [monthlyLeavePreview, setMonthlyLeavePreview] = useState(null);
  const [previewLoading, setPreviewLoading] = useState(false);
  const [previewError, setPreviewError] = useState("");
  const [balanceRefreshKey, setBalanceRefreshKey] = useState(0);
  const [lastApply, setLastApply] = useState(null);

  const calendarDays = React.useMemo(() => {
    if (!startDate || !endDate) return 0;
    const s = new Date(startDate);
    const e = new Date(endDate);
    if (e < s) return 0;
    if (halfDay) return 1;
    return Math.max(1, Math.round((e - s) / 86400000) + 1);
  }, [startDate, endDate, halfDay]);

  const chargeableDays = dayPreview?.chargeableDays ?? 0;

  const fetchRemainingLeaves = async () => {
    try {
      const token = sessionStorage.getItem("token");
      if (!token) {
        setError("No token found. Please log in.");
        return;
      }

      const response = await fetch(`/api/employees/leaves/remainingleaves`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Error fetching remaining leaves");
      }

      const data = await response.json();
      setRemainingLeaves(data.remainingLeave);
      setCompOffAvailable(Number(data.compOffAvailable) || 0);
      setLopDaysTaken(Number(data.lopDaysTaken) || 0);
      setError("");
    } catch (err) {
      console.error("Error:", err);
      setError("Error fetching remaining leaves");
    }
  };

  useEffect(() => {
    fetchRemainingLeaves();
    // SR 224: fetch leave types dynamically so newly created types appear
    const fetchLeaveTypes = async () => {
      try {
        const token = sessionStorage.getItem("token");
        if (!token) return;
        const response = await fetch("/api/leave/types", {
          headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        });
        if (!response.ok) return;
        const data = await response.json();
        const types = data.data || data.leaveTypes || (Array.isArray(data) ? data : []);
        const dynamicOptions = types
          .filter((t) => t.active !== false)
          .map((t) => ({
            value: t.code || t.value || t.name,
            label: t.name || t.label,
            compOffOnly: t.isCompOff || false,
            lopOnly: String(t.code || "").toLowerCase() === "lop",
          }));
        const merged = [...dynamicOptions];
        if (!merged.some((o) => o.value === LOP_LEAVE_VALUE)) {
          merged.push(LOP_OPTION);
        }
        if (!merged.some((o) => o.value === COMP_OFF_LEAVE_VALUE)) {
          merged.push(COMP_OFF_OPTION);
        }
        setLeaveTypeOptions(merged.length ? merged : [LOP_OPTION, COMP_OFF_OPTION]);
      } catch (_) { /* leave default options on error */ }
    };
    fetchLeaveTypes();
  }, []);

  useEffect(() => {
    if (!startDate || !endDate) {
      setDayPreview(null);
      setAllocationPreview(null);
      setMonthlyLeavePreview(null);
      setPreviewError("");
      return;
    }
    const effectiveEnd = halfDay ? startDate : endDate;
    let cancelled = false;
    setPreviewLoading(true);
    setPreviewError("");

    const token = sessionStorage.getItem("token");
    const params = new URLSearchParams({
      startDate,
      endDate: effectiveEnd,
      halfDay: String(halfDay),
    });
    if (leaveType) params.set("leaveType", leaveType);

    fetch(`${endpoints.leave.previewLeaveDays}?${params}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then(async (res) => {
        const data = await res.json();
        if (cancelled) return;
        if (!res.ok) {
          setDayPreview(data.data || null);
          setPreviewError(data.msg || data.summary || "Could not calculate leave days");
          return;
        }
        setDayPreview(data.data || null);
        setAllocationPreview(data.allocation || null);
        setMonthlyLeavePreview(data.monthlyLeave || null);
        setPreviewError("");
      })
      .catch(() => {
        if (!cancelled) {
          setDayPreview(null);
          setAllocationPreview(null);
          setMonthlyLeavePreview(null);
          setPreviewError("Could not calculate leave days");
        }
      })
      .finally(() => {
        if (!cancelled) setPreviewLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [startDate, endDate, halfDay, leaveType]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;

    if (previewError || chargeableDays <= 0) {
      const errMsg = previewError || "Select dates with at least one working day.";
      setError(errMsg);
      setErrorBanner({ open: true, message: errMsg });
      return;
    }

    if (leaveType === COMP_OFF_LEAVE_VALUE && chargeableDays > compOffAvailable) {
      const errMsg = `Insufficient comp-off balance. Available: ${compOffAvailable}, requested: ${chargeableDays}`;
      setError(errMsg);
      setErrorBanner({ open: true, message: errMsg });
      return;
    }

    setSubmitting(true);
    setError("");
    setInsufficientBalanceHint("");
    setErrorBanner({ open: false, message: "" });

    try {
      const token = sessionStorage.getItem("token");
      if (!token) {
        setError("No token found. Please log in.");
        return;
      }

      const decodedToken = JSON.parse(atob(token.split(".")[1]));
      const employeeId = decodedToken.employee.id;

      const requestBody = {
        employeeId,
        leaveType,
        startDate,
        endDate: halfDay ? startDate : endDate,
        reason,
        halfDay,
        halfDaySlot: halfDay ? halfDaySlot : null,
      };

      const response = await fetch(`/api/leave/requests`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      const data = await response.json();

      if (!response.ok) {
        const errMsg = data.msg || data.message || "Error submitting leave request";
        if (data.code === "INSUFFICIENT_LEAVE_BALANCE" || data.suggestLop) {
          setInsufficientBalanceHint(errMsg);
        }
        throw new Error(errMsg);
      }

      const successMsg =
        data.msg ||
        (leaveType === LOP_LEAVE_VALUE
          ? `Leave submitted! ${data.dayBreakdown?.chargeableDays ?? chargeableDays} working day(s) added to LOP. They will be removed if rejected.`
          : `Leave applied successfully! ${data.dayBreakdown?.chargeableDays ?? chargeableDays} working day(s) deducted from your balance. They will be restored if rejected.`);
      setSuccessBanner({ open: true, message: successMsg });
      const appliedType = leaveType;
      const appliedDays = Number(
        data.leaveRequest?.totalDays ?? data.dayBreakdown?.chargeableDays ?? chargeableDays
      ) || 0;
      const appliedPaidRaw = data.leaveRequest?.paidDays ?? data.allocation?.paidDays;
      const appliedPaid = appliedPaidRaw != null && appliedPaidRaw !== "" ? Number(appliedPaidRaw) : appliedDays;
      const appliedCompOff =
        appliedType === COMP_OFF_LEAVE_VALUE
          ? Math.max(0, (Number(compOffAvailable) || 0) - appliedDays)
          : undefined;
      setLastApply({
        token: Date.now(),
        leaveType: appliedType,
        days: appliedDays,
        paidDays: appliedPaid,
        monthlyLeave: data.monthlyLeave || null,
        compOffAvailable: appliedCompOff,
        lopDaysTaken: data.lopDaysTaken,
        lopYearToDate: data.lopYearToDate,
      });
      setLeaveType("");
      setStartDate("");
      setEndDate("");
      setReason("");
      setHalfDay(false);
      setHalfDaySlot("first");
      setDayPreview(null);
      setAllocationPreview(null);
      setMonthlyLeavePreview(null);
      await fetchRemainingLeaves();
      setBalanceRefreshKey((k) => k + 1);
    } catch (err) {
      console.error("Error:", err);
      const errMsg = err.message || "Error submitting leave request";
      setError(errMsg);
      setErrorBanner({ open: true, message: errMsg });
    } finally {
      setSubmitting(false);
    }
  };

  const handleStartDateChange = (e) => {
    const selectedStartDate = e.target.value;
    setStartDate(selectedStartDate);
    if (endDate < selectedStartDate) {
      setEndDate(selectedStartDate);
    }
  };

  return (
    <>
        <Snackbar
          open={successBanner.open}
          autoHideDuration={4500}
          onClose={() => setSuccessBanner((s) => ({ ...s, open: false }))}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          sx={{ top: { xs: 72, sm: 80 }, zIndex: (t) => t.zIndex.snackbar + 2 }}
        >
          <Alert
            onClose={() => setSuccessBanner((s) => ({ ...s, open: false }))}
            severity="success"
            variant="filled"
            iconMapping={{ success: <SendOutlinedIcon fontSize="inherit" /> }}
            sx={{
              width: "100%",
              minWidth: 300,
              maxWidth: 440,
              fontSize: "0.9rem",
              fontWeight: 600,
              boxShadow: "0 8px 24px rgba(0,0,0,0.18)",
              borderRadius: 2,
            }}
          >
            {successBanner.message}
          </Alert>
        </Snackbar>

        <Snackbar
          open={errorBanner.open}
          autoHideDuration={5000}
          onClose={() => setErrorBanner((s) => ({ ...s, open: false }))}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          sx={{ top: { xs: 72, sm: 80 }, zIndex: (t) => t.zIndex.snackbar + 2 }}
        >
          <Alert
            onClose={() => setErrorBanner((s) => ({ ...s, open: false }))}
            severity="error"
            variant="filled"
            sx={{
              width: "100%",
              minWidth: 300,
              maxWidth: 440,
              fontSize: "0.9rem",
              fontWeight: 600,
              boxShadow: "0 8px 24px rgba(0,0,0,0.18)",
              borderRadius: 2,
            }}
          >
            {errorBanner.message}
          </Alert>
        </Snackbar>

        <Box sx={{ px: { xs: 2, sm: 3 }, py: { xs: 2, sm: 2.5 }, maxWidth: 1280, mx: "auto" }}>
          <PageHeader
            title="Apply for Leave"
            subtitle="1.5 days accrue each month. Unused leave adds up; extra days become LOP for that month."
            icon={<BeachAccessOutlinedIcon />}
            actions={[
              <Button
                key="my-leaves"
                variant="outlined"
                size="small"
                startIcon={<ListAltOutlinedIcon />}
                onClick={() => nav("/leave/my")}
                sx={{ textTransform: "none", fontWeight: 600, borderRadius: 2 }}
              >
                My requests
              </Button>,
            ]}
          />

          <LeaveBalanceCards refreshKey={balanceRefreshKey} lastApply={lastApply} />

          <Grid container spacing={2.5}>
            <Grid item xs={12} md={5}>
              <SectionCard title="New leave request" subtitle="Fill in details and submit for approval" accent="#6C50BF" padding={2}>
              <Box
                sx={{
                  position: "relative",
                  opacity: submitting ? 0.72 : 1,
                  transition: "opacity 0.2s ease",
                }}
              >
                {submitting && (
                  <Box
                    sx={{
                      position: "absolute",
                      inset: 0,
                      zIndex: 2,
                      borderRadius: 2,
                      bgcolor: "rgba(255,255,255,0.55)",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 1,
                    }}
                  >
                    <CircularProgress size={36} thickness={4} />
                    <Typography sx={{ fontSize: 13, fontWeight: 600, color: "primary.main" }}>
                      Submitting your leave request…
                    </Typography>
                  </Box>
                )}
                <Box
                  component="form"
                  onSubmit={handleSubmit}
                  sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}
                >
                  {/* Leave Type Dropdown with Image-Like UI */}
                  <TextField
                    select
                    variant="outlined"
                    label="Leave Type"
                    value={leaveType}
                    onChange={(e) => {
                      setLeaveType(e.target.value);
                      setInsufficientBalanceHint("");
                    }}
                    required
                    fullWidth
                    size="small"
                    disabled={submitting}
                    SelectProps={{
                      MenuProps: {
                        PaperProps: {
                          sx: {
                            borderRadius: "12px",
                            boxShadow: "0px 4px 16px rgba(0,0,0,0.1)",
                            mt: 1,
                            maxHeight: "250px", // optional scroll height
                          },
                        },
                        disableScrollLock: true, // << IMPORTANT: lets it scroll naturally and hides on page scroll
                      },
                    }}
                    InputProps={{
                      sx: {
                        borderRadius: "10px",
                        backgroundColor: "#fff",
                      },
                    }}
                  >
                    {sortByLabel(leaveTypeOptions, (item) => item.label).map((item) => {
                      const disabled = item.compOffOnly && compOffAvailable <= 0;
                      return (
                        <MenuItem
                          key={item.value}
                          value={item.value}
                          disabled={disabled}
                          sx={{
                            borderRadius: "8px",
                            paddingY: "8px",
                            paddingX: "12px",
                            marginX: "6px",
                            transition: "all 0.2s",
                            "&:hover": {
                              backgroundColor: "grey.50",
                            },
                          }}
                        >
                          {item.label}
                          {item.compOffOnly ? ` (${compOffAvailable} available)` : ""}
                        </MenuItem>
                      );
                    })}

                  </TextField>

                  {leaveType === COMP_OFF_LEAVE_VALUE && (
                    <Alert severity="info" sx={{ borderRadius: 2 }}>
                      Uses your comp-off bank ({compOffAvailable} day{compOffAvailable === 1 ? "" : "s"} available).
                      Days are deducted when you apply and restored if the manager rejects.
                    </Alert>
                  )}

                  {leaveType === LOP_LEAVE_VALUE && (
                    <Alert severity="warning" sx={{ borderRadius: 2 }}>
                      <Typography variant="body2" sx={{ fontWeight: 700, mb: 0.5 }}>
                        Loss of Pay — no paid leave balance required
                      </Typography>
                      <Typography variant="body2">
                        After you apply, working days are added to your LOP total (currently{" "}
                        <strong>{lopDaysTaken}</strong> day{lopDaysTaken === 1 ? "" : "s"}). They are
                        removed if the manager rejects. Salary may be affected for unpaid days.
                      </Typography>
                    </Alert>
                  )}

                  {insufficientBalanceHint && leaveType !== LOP_LEAVE_VALUE && (
                    <Alert
                      severity="error"
                      sx={{ borderRadius: 2 }}
                      action={
                        <Button
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setLeaveType(LOP_LEAVE_VALUE);
                            setInsufficientBalanceHint("");
                            setError("");
                          }}
                        >
                          Use LOP
                        </Button>
                      }
                    >
                      {insufficientBalanceHint}
                    </Alert>
                  )}

                  {/* Half-Day Toggle */}
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2, flexWrap: "wrap" }}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={halfDay}
                          disabled={submitting}
                          onChange={(e) => {
                            setHalfDay(e.target.checked);
                            if (e.target.checked && startDate) setEndDate(startDate);
                          }}
                          size="small"
                        />
                      }
                      label={<Typography fontSize="0.9rem">Half-day leave</Typography>}
                    />
                    {halfDay && (
                      <RadioGroup
                        row
                        value={halfDaySlot}
                        onChange={(e) => setHalfDaySlot(e.target.value)}
                      >
                        <FormControlLabel value="first" control={<Radio size="small" />} label={<Typography fontSize="0.85rem">First half (AM)</Typography>} />
                        <FormControlLabel value="second" control={<Radio size="small" />} label={<Typography fontSize="0.85rem">Second half (PM)</Typography>} />
                      </RadioGroup>
                    )}
                  </Box>

                  {/* Start Date */}
                  <TextField
                    type="date"
                    label={halfDay ? "Date" : "Start Date"}
                    variant="outlined"
                    value={startDate}
                    onChange={(e) => {
                      handleStartDateChange(e);
                      if (halfDay) setEndDate(e.target.value);
                    }}
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    required
                    size="small"
                    disabled={submitting}
                    InputProps={{ sx: { borderRadius: "10px" } }}
                  />

                  {/* End Date - hidden for half-day */}
                  {!halfDay && (
                    <TextField
                      type="date"
                      label="End Date"
                      variant="outlined"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                      required
                      size="small"
                      disabled={submitting}
                      inputProps={{ min: startDate }}
                      InputProps={{ sx: { borderRadius: "10px" } }}
                    />
                  )}

                  {/* Leave day breakdown */}
                  {startDate && endDate && (
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                      {previewLoading ? (
                        <Stack direction="row" spacing={1} alignItems="center">
                          <CircularProgress size={16} />
                          <Typography variant="body2" color="text.secondary">
                            Calculating working days…
                          </Typography>
                        </Stack>
                      ) : previewError ? (
                        <Alert severity="warning" sx={{ borderRadius: 2 }}>
                          {previewError}
                        </Alert>
                      ) : dayPreview && chargeableDays > 0 ? (
                        <>
                          <LeaveApplyAllocationPreview
                            allocation={allocationPreview}
                            monthlyLeave={monthlyLeavePreview}
                            chargeableDays={chargeableDays}
                            leaveType={leaveType}
                          />
                          {dayPreview.excludedDays > 0 && (
                            <Typography variant="caption" color="text.secondary" component="div">
                              Excluded from balance:{" "}
                              {[
                                dayPreview.breakdown?.holidays
                                  ? `${dayPreview.breakdown.holidays} holiday(s)`
                                  : null,
                                dayPreview.breakdown?.sundays
                                  ? `${dayPreview.breakdown.sundays} Sunday(s)`
                                  : null,
                                dayPreview.breakdown?.saturdaysOff
                                  ? `${dayPreview.breakdown.saturdaysOff} Saturday off`
                                  : null,
                              ]
                                .filter(Boolean)
                                .join(", ")}
                            </Typography>
                          )}
                          {dayPreview.excluded?.length > 0 && (
                            <Typography variant="caption" color="text.secondary" component="div" sx={{ mt: 0.5 }}>
                              {dayPreview.excluded
                                .slice(0, 5)
                                .map((e) => `${e.date} (${e.label})`)
                                .join(" · ")}
                              {dayPreview.excluded.length > 5 ? " …" : ""}
                            </Typography>
                          )}
                        </>
                      ) : null}
                    </Box>
                  )}

                  {/* Reason Field */}
                  <TextField
                    label="Reason for Leave"
                    variant="outlined"
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    multiline
                    minRows={2}
                    maxRows={3}
                    fullWidth
                    size="small"
                    disabled={submitting}
                    InputProps={{
                      sx: {
                        borderRadius: "10px",
                        fontSize: "0.85rem",
                        lineHeight: "1.2rem",
                        padding: "6px 8px",
                      },
                    }}
                  />

                  <Button
                    type="submit"
                    variant="contained"
                    disabled={submitting || previewLoading || chargeableDays <= 0 || !!previewError}
                    startIcon={
                      submitting ? (
                        <CircularProgress size={16} color="inherit" />
                      ) : (
                        <SendOutlinedIcon />
                      )
                    }
                    sx={{
                      alignSelf: "flex-start",
                      borderRadius: 2,
                      textTransform: "none",
                      fontWeight: 700,
                      fontSize: "0.85rem",
                      px: 2.5,
                      py: 1,
                      bgcolor: "#6C50BF",
                      "&:hover": { bgcolor: "#5a43a8" },
                      "&.Mui-disabled": { bgcolor: "#b8aed4", color: "#fff" },
                    }}
                  >
                    {submitting ? "Processing…" : "Submit request"}
                  </Button>

                  {error && !errorBanner.open && (
                    <Alert severity="error" sx={{ py: 0.25, fontSize: "0.8rem", mt: 0.5 }}>
                      {error}
                    </Alert>
                  )}
                </Box>
              </Box>
              </SectionCard>
            </Grid>

            <Grid item xs={12} md={7}>
              <SectionCard
                title="Guidelines"
                subtitle="Quick reference before you apply"
                accent="#5C85FF"
                padding={2}
              >
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                      <EventAvailableOutlinedIcon sx={{ fontSize: 18, color: "#6C50BF" }} />
                      <Typography sx={{ fontSize: 13, fontWeight: 700 }}>Leave types</Typography>
                    </Stack>
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                      {[
                        { type: "Monthly leave", days: "1.5 / month, unused adds up" },
                        { type: "Extra days", days: "Become LOP that month" },
                        { type: "Comp-off", days: "From extra work days" },
                        { type: "Explicit LOP", days: "All days unpaid" },
                      ].map((leave) => (
                        <Box
                          key={leave.type}
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            px: 1.25,
                            py: 0.75,
                            borderRadius: 1.5,
                            bgcolor: "action.hover",
                          }}
                        >
                          <Typography sx={{ fontSize: 12, fontWeight: 600 }}>{leave.type}</Typography>
                          <Chip label={leave.days} size="small" sx={{ height: 22, fontSize: 10, fontWeight: 600 }} />
                        </Box>
                      ))}
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography sx={{ fontSize: 13, fontWeight: 700, mb: 1 }}>Important notes</Typography>
                    <Box component="ul" sx={{ m: 0, pl: 2.25 }}>
                      {[
                        "Sundays, 1st/3rd/5th Saturdays, and company holidays are not deducted",
                        "Leave days are deducted from your balance as soon as you apply",
                        "If the manager rejects the request, those days are added back",
                        "Submit at least 2 days in advance when possible",
                        "Medical certificate for sick leave over 3 days",
                        "Manager approval required for all requests",
                        "Half-day: single date, AM or PM slot",
                      ].map((note) => (
                        <Typography
                          key={note}
                          component="li"
                          sx={{ fontSize: 12, color: "text.secondary", mb: 0.75, lineHeight: 1.45 }}
                        >
                          {note}
                        </Typography>
                      ))}
                    </Box>
                  </Grid>
                </Grid>
              </SectionCard>
            </Grid>
          </Grid>
        </Box>
    </>
  );
};

export default LeaveRequestForm;
